import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import { Input } from '@material-ui/core';
import { isValidTag } from '../../helpers/Util';
import Error from '../Error';
import AssetTagsList from './AssetTagsList';
import * as tagsConstants from '../../constants/tags';

class AssetTagsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tagValue: '',
        }
    }

    onChangeInput = (event) => {
        const value = event.target.value.toLowerCase();
        this.setState({
            tagValue: value,
        });
    }

    onTagSelected = (tagValue, idx, isAlreadySelected) => {
        const { assetTags, onUpdateTags } = this.props;
        const newAssetTags = isAlreadySelected ? assetTags.toSpliced(idx, 1) : assetTags.concat(tagValue);
        onUpdateTags(newAssetTags);
    }

    onAddTag = (tagValue) => {
        const { assetTags, onUpdateTags, addTag } = this.props;
        const newAssetTags = assetTags.concat(tagValue);
        onUpdateTags(newAssetTags);
        addTag(tagValue);
        this.setState({ tagValue: '' });
    }

    render() {
        const { assetTags, tags, classes, onClose } = this.props;
        const { tagValue } = this.state;

        // search for tag with space instead fo empty spaces since tags cannot include empty spaces
        // ex. tag 1 is equal to tag_1 in tags array
        const tagWithoutSpaces = tagValue && tagValue.replace(/\s+/g, '_');
        const isTagValid = !tagValue || isValidTag(tagValue); // we don't want error message when the tagValue is empty string
        const isTagValueNew = tagWithoutSpaces && tags.indexOf(tagWithoutSpaces) === -1;
        const addTag = isTagValueNew && isTagValid ? (<div className={classes.addNewTag} onClick={() => this.onAddTag(tagWithoutSpaces)}>
            <i className={classNames(classes.addNewTagIcon, "material-icons")}>add</i>
            <div className={classes.createTagButton}>Create "{tagValue}"</div>
        </div>) : null;


        return (
            <div className={classes.container}>
                <div className={classes.modal}>
                    <div className={classes.header}>
                        <p>Tags</p>
                    </div>
                    <div className={classes.inputContainer}>
                        <Input
                            placeholder="Search/Add Tags..."
                            className={classes.input}
                            endAdornment={
                                <i className="material-icons">search</i>
                            }
                            type='text'
                            onChange={this.onChangeInput}
                            value={tagValue}
                            error={!isTagValid}
                        />
                        <Error>{!isTagValid && 'Tag is not valid'}</Error>
                    </div>
                    {addTag}
                    <AssetTagsList
                        tagWithoutSpaces={tagWithoutSpaces}
                        assetTags={assetTags}
                        tags={tags}
                        onTagSelected={this.onTagSelected}
                    />
                </div>
                <div className={classes.background} onClick={onClose} />
            </div>
        );
    };
}

AssetTagsModal.propTypes = {
    classes: PropTypes.object,
    tags: PropTypes.array.isRequired,
    assetTags: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdateTags: PropTypes.func.isRequired,
};

const style = ({ palette }) => ({
    container: {
        width: 0,
        height: 0,
    },
    header: {
        paddingTop: 10,
        paddingLeft: 30,
    },
    inputContainer: {
        paddingLeft: 30,
        paddingRight: 30,
        marginTop: 15,
    },
    addNewTag: {
        marginTop: 10,
        paddingTop: 5,
        paddingBottom: 5,
        paddingRight: 30,
        wordWrap: 'breake-word',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: palette.background.gray3Color,
        }
    },
    addNewTagIcon: {
        marginLeft: 30,
        paddingRight: 5,
    },
    modal: {
        backgroundColor: 'white',
        width: 300,
        height: 'auto',
        position: 'relative',
        left: -330,
        bottom: -20,
        zIndex: '128',
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0,0,0,0.12), 0 8px 8px 0 rgba(0,0,0,0.08)',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
    },
    createTagButton: {
        maxWidth: 200,
        overflow: 'hidden',
        whiteSpace: 'nowrap', 
        textOverflow: 'ellipsis'
    }
});

const mapDispatchToProps = dispatch => ({
    addTag: (tag) => {
        dispatch({
            type: tagsConstants.ADD_TAG,
            payload: tag,
        });
    },
});

const mapStateToProps = state => ({
    tags: state.tags.tagsList || [],
});

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(style)(AssetTagsModal));



// WEBPACK FOOTER //
// ./src/components/modals/AssetTagsModal.js